/* SpeakerCalc — beregningslogik for bekent.dk
   Kraever: assets/speakercalc-vaerdier.js (window.SPEAKERCALC_VAERDIER)
   Indlaeses af sections/speakercalc.liquid.
   Udskrift: knappen "Udskriv / gem som PDF" og Ctrl+P bygger en separat
   rapport (#sc-print) nederst i body. Styling ligger i speakercalc.css.
   BEMAERK: overlever ikke en temaopdatering — laeg filen ind igen bagefter. */

(function () {
  "use strict";

  var CFG = {
    ebp: { lav: 50, hoej: 90 },
    k2: {
      lr:     { kC: 0.0796, kL: 0.3183, navn: "Linkwitz-Riley", q: "0,50",
                note: "Flad sum ved delefrekvensen. Diskanten skal kobles i omvendt fase." },
      bessel: { kC: 0.0912, kL: 0.2756, navn: "Bessel", q: "0,58",
                note: "Bedste transientgengivelse og det blødeste knæk." },
      bw:     { kC: 0.1125, kL: 0.2251, navn: "Butterworth", q: "0,71",
                note: "Flad i pasbåndet, men giver ca. +3 dB ved delefrekvensen." },
      cheb:   { kC: 0.1592, kL: 0.1592, navn: "Chebyshev", q: "1,00",
                note: "Stejlest knæk, men ripple i pasbåndet." }
    },
    k4: {
      hp: [ { t: "C", p: "s", k: 0.0844 }, { t: "L", p: "p", k: 0.1000 },
            { t: "C", p: "s", k: 0.1688 }, { t: "L", p: "p", k: 0.4501 } ],
      lp: [ { t: "L", p: "s", k: 0.3000 }, { t: "C", p: "p", k: 0.0563 },
            { t: "L", p: "s", k: 0.1500 }, { t: "C", p: "p", k: 0.2533 } ]
    },
    portK: 0.732,
    links: {
      C: { kollektion: "kondensatorer", felt: "specs.kondensator_uf", liste: "kondensator_uf", navn: "kondensatorer" },
      L: { kollektion: "spoler",        felt: "specs.inductance_mh",  liste: "inductance_mh",  navn: "spoler" },
      R: { kollektion: "modstande",     felt: "specs.modstand",       liste: "modstand",       navn: "modstande" }
    }
  };

  var S = {
    fs: 55, qes: 0.38, qts: 0.38, vas: 50,
    qtc: 0.7, vb: 20, fb: 40, dport: 7, nport: 1,
    kabH: 400, kabB: 250, kabD: 300, kabT: 19, kabN: 1,
    fc: 3000, zt: 8, zw: 8, zm: 8, orden: "2",
    f1: 500, f2: 3000,
    topo: "lr", db: 6, zpad: 8
  };

  function num(v) {
    if (v === null || v === undefined) return NaN;
    return parseFloat(String(v).replace(",", "."));
  }

  function fmt(v, d) {
    if (!isFinite(v)) return "\u2014";
    return v.toFixed(d === undefined ? 2 : d).replace(".", ",");
  }

  function urlTal(v) {
    var s = v.toFixed(6);
    s = s.replace(/0+$/, "").replace(/\.$/, ".0");
    return s;
  }

  function esc(s) {
    return String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  }

  function naermeste(raa, listeNavn) {
    var d = window.SPEAKERCALC_VAERDIER;
    if (!d || !d[listeNavn] || !d[listeNavn].length) return null;
    var liste = d[listeNavn], bedst = liste[0], afstand = Infinity;
    for (var i = 0; i < liste.length; i++) {
      var a = Math.abs(Math.log(liste[i] / raa));
      if (a < afstand) { afstand = a; bedst = liste[i]; }
    }
    return bedst;
  }

  function filterLink(type, vaerdi) {
    var L = CFG.links[type];
    if (!L || vaerdi === null) return null;
    return "/collections/" + L.kollektion +
           "?sort_by=best-selling&filter.p.m." + L.felt + "=" + urlTal(vaerdi);
  }

  function afvigelse(raa, valgt) {
    if (valgt === null || !isFinite(raa) || raa === 0) return null;
    return (valgt - raa) / raa * 100;
  }

  function komponentRaekke(c) {
    var erC = c.t === "C", erR = c.t === "R";
    var enhed = erC ? "\u00b5F" : (erR ? "\u03a9" : "mH");
    var raa = erC ? c.v * 1e6 : (erR ? c.v : c.v * 1e3);
    var valgt = naermeste(raa, CFG.links[c.t].liste);
    var afv = afvigelse(raa, valgt);
    var d = raa < 1 ? 3 : (raa < 10 ? 2 : 1);
    var link = filterLink(c.t, valgt);
    var navn = erC ? "Kondensator" : (erR ? "Modstand" : "Spole");
    var placering = c.p === "s" ? "i serie" : "parallelt";

    var visning, ekstra;
    if (valgt === null) {
      visning = fmt(raa, d) + " " + enhed;
      ekstra = "beregnet";
    } else {
      visning = fmt(valgt, valgt < 1 ? 3 : (valgt < 10 ? 2 : 1)) + " " + enhed;
      if (Math.abs(afv) < 0.5) {
        ekstra = "beregnet " + fmt(raa, d);
      } else {
        ekstra = "beregnet " + fmt(raa, d) + " \u00b7 " +
                 (afv > 0 ? "+" : "") + fmt(afv, 1) + "\u00a0%";
      }
    }

    var knap = link
      ? '<a class="sc-koeb" href="' + link + '">Se ' + CFG.links[c.t].navn + "</a>"
      : "";

    return '<tr>' +
      '<td class="sc-ref">' + c.ref + '</td>' +
      '<td>' + navn + ' <span class="sc-lille">\u2014 ' + placering + '</span></td>' +
      '<td class="sc-vaerdi">' + visning + '</td>' +
      '<td class="sc-beregnet">' + ekstra + '</td>' +
      '<td class="sc-buy">' + knap + '</td>' +
      '</tr>';
  }

  /* Loebenumre gaar paa tvaers af hele filteret, ikke pr. gren.
     Ellers hedder tre forskellige spoler alle sammen L1. */
  var TAEL = { C: 0, L: 0, R: 0 };

  function nulstilNumre() { TAEL = { C: 0, L: 0, R: 0 }; }

  function nummerer(liste) {
    liste.forEach(function (c) { TAEL[c.t]++; c.ref = c.t + TAEL[c.t]; });
    return liste;
  }

  function komponentTabel(titel, liste) {
    nummerer(liste);
    return '<table class="sc-parts"><caption>' + titel + '</caption>' +
      '<thead><tr><th>Ref</th><th>Komponent</th><th>V\u00e6rdi</th>' +
      '<th>Beregnet</th><th></th></tr></thead><tbody>' +
      liste.map(komponentRaekke).join("") + '</tbody></table>';
  }

  function gren(liste, label, enhedNavn, y) {
    var x = 76, s = "", trin = 62;
    s += '<text x="4" y="' + (y + 4) + '" class="sc-svg-lbl">' + label + '</text>';
    s += '<circle cx="42" cy="' + y + '" r="3" class="sc-svg-pin"/>';
    s += '<circle cx="42" cy="' + (y + 56) + '" r="3" class="sc-svg-pin"/>';
    s += '<line x1="45" y1="' + y + '" x2="' + x + '" y2="' + y + '" class="sc-svg-wire"/>';

    liste.forEach(function (c) {
      if (c.p === "s") {
        if (c.t === "C") {
          s += '<line x1="' + x + '" y1="' + y + '" x2="' + (x + 13) + '" y2="' + y + '" class="sc-svg-wire"/>' +
               '<line x1="' + (x + 13) + '" y1="' + (y - 9) + '" x2="' + (x + 13) + '" y2="' + (y + 9) + '" class="sc-svg-part"/>' +
               '<line x1="' + (x + 19) + '" y1="' + (y - 9) + '" x2="' + (x + 19) + '" y2="' + (y + 9) + '" class="sc-svg-part"/>' +
               '<line x1="' + (x + 19) + '" y1="' + y + '" x2="' + (x + trin) + '" y2="' + y + '" class="sc-svg-wire"/>';
        } else if (c.t === "R") {
          s += '<line x1="' + x + '" y1="' + y + '" x2="' + (x + 8) + '" y2="' + y + '" class="sc-svg-wire"/>' +
               '<rect x="' + (x + 8) + '" y="' + (y - 6) + '" width="24" height="12" class="sc-svg-part" fill="none"/>' +
               '<line x1="' + (x + 32) + '" y1="' + y + '" x2="' + (x + trin) + '" y2="' + y + '" class="sc-svg-wire"/>';
        } else {
          s += '<line x1="' + x + '" y1="' + y + '" x2="' + (x + 8) + '" y2="' + y + '" class="sc-svg-wire"/>' +
               '<path d="M' + (x + 8) + ' ' + y + ' a5 5 0 0 1 8 0 a5 5 0 0 1 8 0 a5 5 0 0 1 8 0" fill="none" class="sc-svg-part"/>' +
               '<line x1="' + (x + 32) + '" y1="' + y + '" x2="' + (x + trin) + '" y2="' + y + '" class="sc-svg-wire"/>';
        }
        s += '<text x="' + (x + 17) + '" y="' + (y - 16) + '" text-anchor="middle" class="sc-svg-ref">' + c.ref + '</text>';
      } else {
        var yb = y + 56;
        if (c.t === "C") {
          s += '<line x1="' + x + '" y1="' + y + '" x2="' + x + '" y2="' + (y + 20) + '" class="sc-svg-wire"/>' +
               '<line x1="' + (x - 10) + '" y1="' + (y + 20) + '" x2="' + (x + 10) + '" y2="' + (y + 20) + '" class="sc-svg-part"/>' +
               '<line x1="' + (x - 10) + '" y1="' + (y + 26) + '" x2="' + (x + 10) + '" y2="' + (y + 26) + '" class="sc-svg-part"/>' +
               '<line x1="' + x + '" y1="' + (y + 26) + '" x2="' + x + '" y2="' + yb + '" class="sc-svg-wire"/>';
        } else if (c.t === "R") {
          s += '<line x1="' + x + '" y1="' + y + '" x2="' + x + '" y2="' + (y + 14) + '" class="sc-svg-wire"/>' +
               '<rect x="' + (x - 6) + '" y="' + (y + 14) + '" width="12" height="24" class="sc-svg-part" fill="none"/>' +
               '<line x1="' + x + '" y1="' + (y + 38) + '" x2="' + x + '" y2="' + yb + '" class="sc-svg-wire"/>';
        } else {
          s += '<line x1="' + x + '" y1="' + y + '" x2="' + x + '" y2="' + (y + 14) + '" class="sc-svg-wire"/>' +
               '<path d="M' + x + ' ' + (y + 14) + ' a5 5 0 0 0 0 8 a5 5 0 0 0 0 8 a5 5 0 0 0 0 8" fill="none" class="sc-svg-part"/>' +
               '<line x1="' + x + '" y1="' + (y + 38) + '" x2="' + x + '" y2="' + yb + '" class="sc-svg-wire"/>';
        }
        s += '<text x="' + (x + 14) + '" y="' + (y + 30) + '" class="sc-svg-ref">' + c.ref + '</text>';
        s += '<line x1="' + x + '" y1="' + y + '" x2="' + (x + trin) + '" y2="' + y + '" class="sc-svg-wire"/>';
      }
      x += trin;
    });

    s += '<line x1="' + x + '" y1="' + y + '" x2="' + (x + 16) + '" y2="' + y + '" class="sc-svg-wire"/>' +
         '<circle cx="' + (x + 16) + '" cy="' + y + '" r="3" class="sc-svg-pin"/>' +
         '<text x="' + (x + 26) + '" y="' + (y + 4) + '" class="sc-svg-drv">' + enhedNavn + '</text>' +
         '<line x1="45" y1="' + (y + 56) + '" x2="' + (x + 16) + '" y2="' + (y + 56) + '" class="sc-svg-wire"/>' +
         '<circle cx="' + (x + 16) + '" cy="' + (y + 56) + '" r="3" class="sc-svg-pin"/>';
    return { s: s, w: x + 120 };
  }

  function diagram(grene) {
    var ud = "", w = 460, y = 26;
    grene.forEach(function (g) {
      var r = gren(g.liste, "IND", g.enhed, y);
      ud += r.s; w = Math.max(w, r.w); y += 104;
    });
    return '<div class="sc-diagram"><h4>Principdiagram</h4>' +
      '<svg viewBox="0 0 ' + w + ' ' + (y - 20) + '" xmlns="http://www.w3.org/2000/svg" ' +
      'role="img" aria-label="Diagram over filterets opbygning">' + ud + '</svg>' +
      '<div class="sc-legend"><span><b>L</b> = spole (mH)</span>' +
      '<span><b>C</b> = kondensator (\u00b5F)</span>' +
      '<span><b>R</b> = modstand (\u03a9)</span>' +
      '<span>Lodret komponent sidder parallelt over enheden</span></div></div>';
  }

  function hovedResultat(lbl, vaerdi, enhed, under, anbLbl, anbTitel, anbTekst, navyTal) {
    return '<div class="sc-result">' +
      '<div class="sc-big"><div class="sc-lbl">' + lbl + '</div>' +
      '<div class="sc-val' + (navyTal ? " sc-navy" : "") + '">' + vaerdi +
      (enhed ? '<span class="sc-u"> ' + enhed + "</span>" : "") + "</div>" +
      '<div class="sc-calcline">' + under + "</div></div>" +
      '<div class="sc-rec"><div class="sc-lbl-g">' + anbLbl + "</div>" +
      "<h3>" + anbTitel + "</h3><p>" + anbTekst + "</p></div></div>";
  }

  function specBoks(raekker) {
    return '<div class="sc-spec">' + raekker.map(function (r) {
      return "<div><div class=\"sc-k\">" + r[0] + "</div><div class=\"sc-v\">" + r[1] +
        (r[2] ? " <small>" + r[2] + "</small>" : "") + "</div></div>";
    }).join("") + "</div>";
  }

  function infoBoks(titel, html, variant) {
    return '<div class="sc-info' + (variant ? " sc-" + variant : "") + '">' +
      '<div class="sc-info-t">' + titel + "</div>" + html + "</div>";
  }

  var B = {};

  B.ebp = {
    felter: [
      { id: "fs", label: "F<sub>s</sub> (resonansfrekvens)", enhed: "Hz", hjaelp: "Enhedens frie resonansfrekvens \u2014 står i databladet." },
      { id: "qes", label: "Q<sub>es</sub> (elektrisk Q)", enhed: "", hjaelp: "Elektrisk godhedsfaktor ved resonans. Bestemt af magnet og svingspole." }
    ],
    knap: "Beregn EBP",
    ud: function () {
      if (!(S.fs > 0 && S.qes > 0)) {
        return infoBoks("Udfyld felterne", "<p>Både F<sub>s</sub> og Q<sub>es</sub> skal v\u00e6re st\u00f8rre end nul.</p>", "warn");
      }
      var v = S.fs / S.qes;
      var z = v < CFG.ebp.lav ? 0 : (v <= CFG.ebp.hoej ? 1 : 2);
      var svar = [
        ["Lukket kabinet", "En EBP-v\u00e6rdi under " + CFG.ebp.lav + " betyder, at enheden er for kraftigt d\u00e6mpet til at drive en port effektivt. Et lukket kabinet giver den mest kontrollerede bas."],
        ["Begge typer kan bruges", "En EBP-v\u00e6rdi mellem " + CFG.ebp.lav + " og " + CFG.ebp.hoej + " g\u00f8r enheden alsidig. V\u00e6lg lukket for kontrol, basrefleks for niveau i bunden."],
        ["Basrefleks kabinet", "En EBP-v\u00e6rdi over " + CFG.ebp.hoej + " indikerer, at basrefleks er det bedste valg for optimal ydeevne."]
      ][z];

      var pos = z === 0 ? Math.min(v, CFG.ebp.lav) / CFG.ebp.lav * 33
              : (z === 1 ? 33 + (v - CFG.ebp.lav) / (CFG.ebp.hoej - CFG.ebp.lav) * 33
                         : 66 + Math.min((v - CFG.ebp.hoej) / 110, 1) * 32);

      var h = hovedResultat("Din EBP-v\u00e6rdi", fmt(v, 0), "",
        "EBP = Fs / Qes = " + fmt(S.fs, 0) + " / " + fmt(S.qes, 2),
        "Anbefaling", svar[0], svar[1], z === 1);

      h += '<div class="sc-scale"><div class="sc-bar">' +
        '<i class="sc-b1"></i><i class="sc-b2"></i><i class="sc-b3"></i>' +
        '<span class="sc-dot" style="left:' + pos.toFixed(1) + '%"></span></div>' +
        '<div class="sc-lg"><span><b>&lt; ' + CFG.ebp.lav + "</b>Lukket</span>" +
        "<span><b>" + CFG.ebp.lav + "\u2013" + CFG.ebp.hoej + "</b>Begge</span>" +
        "<span><b>&gt; " + CFG.ebp.hoej + "</b>Basrefleks</span></div></div>";

      h += infoBoks("Om EBP",
        "<p>EBP (Efficiency Bandwidth Product) er en tommelfingerregel, ikke en facitliste. Formlen er <code>EBP = Fs / Qes</code>. " +
        "Jo h\u00f8jere v\u00e6rdi, desto mere velegnet er enheden til basrefleks. Q<sub>ts</sub>, V<sub>AS</sub> og hvor dybt du vil ned spiller ogs\u00e5 ind.</p>");
      return h;
    }
  };

  B.lukket = {
    felter: [
      { id: "vas", label: "V<sub>AS</sub>", enhed: "liter", hjaelp: "Det luftvolumen, der er lige så fjedrende som enhedens ophæng." },
      { id: "qts", label: "Q<sub>ts</sub>", enhed: "", hjaelp: "Enhedens samlede godhedsfaktor. Under 0,5 peger mod basrefleks." },
      { id: "fs", label: "F<sub>s</sub>", enhed: "Hz", hjaelp: "Enhedens frie resonansfrekvens." },
      { id: "qtc", label: "Q<sub>tc</sub> (\u00f8nsket system-Q)", type: "select",
        hjaelp: "Hvor hårdt kabinettet dæmper. Lavere Q giver strammere bas og større kabinet.",
        valg: [["0.5", "0,5 \u2014 kritisk d\u00e6mpet, strammest bas"],
               ["0.7", "0,7 \u2014 maksimalt flad (Butterworth)"],
               ["0.8", "0,8 \u2014 lidt mere fylde"],
               ["1.0", "1,0 \u2014 markant bump, mindst kabinet"]],
        hint: "0,7 er det almindelige valg til hi-fi." }
    ],
    knap: "Beregn kabinet",
    ud: function () {
            var a = Math.pow(S.qtc / S.qts, 2) - 1;
      var vb = S.vas / a;
      var fc = S.fs * (S.qtc / S.qts);
      var t = 1 / (S.qtc * S.qtc) - 2;
      var f3 = fc * Math.sqrt((t + Math.sqrt(t * t + 4)) / 2);

            /* Ingen spaerring. Et negativt volumen er selv forklaringen paa,
         at kombinationen ikke findes — en fejlbesked laeses som en
         programfejl, et minustal laeses som et svar. */
      var umuligt = a <= 0;

      var h = hovedResultat("Nettovolumen", fmt(vb, 1), "l", "Vb = VAS / \u03b1", "Kabinet",
        umuligt
          ? "Negativt volumen \u2014 kombinationen findes ikke"
          : fmt(vb, 1) + " liter netto ved Q<sub>tc</sub> " + fmt(S.qtc, 2),
        umuligt
          ? "Et lukket kabinet kan kun h\u00e6ve enhedens Q, aldrig s\u00e6nke den. Med Q<sub>ts</sub> = " +
            fmt(S.qts, 2) + " kan systemet ikke ende p\u00e5 Q<sub>tc</sub> " + fmt(S.qtc, 2) +
            " \u2014 uanset hvor stort eller lille kabinettet er."
          : ((Math.abs(fc - f3) < 0.1
              ? "Systemet resonerer ved " + fmt(fc, 1) + " Hz og er 3 dB nede samme sted \u2014 det er netop, hvad Q<sub>tc</sub> 0,7 betyder."
              : "Systemet resonerer ved " + fmt(fc, 1) + " Hz og er 3 dB nede ved " + fmt(f3, 1) + " Hz.") +
             " L\u00e6g rumfanget af enhed, delefilter og afstivninger oveni, n\u00e5r du tegner kabinettet."));

      if (umuligt) {
        h += infoBoks("L\u00f8sningsforslag",
          "<p>H\u00e6v \u00f8nsket system-Q (Q<sub>tc</sub>) til en v\u00e6rdi over Q<sub>ts</sub> = " +
          fmt(S.qts, 2) + ". Alternativt kan du v\u00e6lge en enhed med lavere Q<sub>ts</sub>.</p>", "warn");
      }

      h += specBoks([
             ["Systemresonans F<sub>c</sub>", fmt(fc, 1), "Hz"],
        ["\u22123 dB ved F<sub>3</sub>", fmt(f3, 1), "Hz"],
        ["Compliance-forhold \u03b1", fmt(a, 3), ""]
      ]);

      h += infoBoks("S\u00e5dan er det regnet",
        "<p><code>\u03b1 = (Qtc/Qts)\u00b2 \u2212 1 = " + fmt(a, 3) + "</code> \u00b7 " +
        "<code>Vb = VAS/\u03b1 = " + fmt(vb, 1) + " l</code> \u00b7 " +
        "<code>Fc = Fs\u00b7(Qtc/Qts) = " + fmt(fc, 1) + " Hz</code></p>");
      return h;
    }
  };
  /* Omvendt af B.lukket: kender man kabinettet, faar man systemets Q. */
  B.lukketq = {
    felter: [
      { id: "vb", label: "Kabinettets nettovolumen", enhed: "liter", hjaelp: "Det indvendige rumfang, fratrukket enhed, delefilter og afstivninger." },
      { id: "vas", label: "V<sub>AS</sub>", enhed: "liter", hjaelp: "Det luftvolumen, der er lige så fjedrende som enhedens ophæng." },
      { id: "qts", label: "Q<sub>ts</sub>", enhed: "", hjaelp: "Enhedens samlede godhedsfaktor." },
      { id: "fs", label: "F<sub>s</sub>", enhed: "Hz", hjaelp: "Enhedens frie resonansfrekvens." }
    ],
    knap: "Beregn system-Q",
    ud: function () {
      if (!(S.vb > 0 && S.vas > 0 && S.qts > 0 && S.fs > 0)) {
        return infoBoks("Udfyld felterne", "<p>Alle fire felter skal v\u00e6re st\u00f8rre end nul.</p>", "warn");
      }
      var a = S.vas / S.vb;
      var qtc = S.qts * Math.sqrt(a + 1);
      var fc = S.fs * (qtc / S.qts);
      var t = 1 / (qtc * qtc) - 2;
      var f3 = fc * Math.sqrt((t + Math.sqrt(t * t + 4)) / 2);

      var d;
      if (qtc < 0.6) d = ["Stram og t\u00f8r", "Kontrolleret bas uden bump, men kabinettet er stort, og der er ikke meget niveau i bunden."];
      else if (qtc < 0.85) d = ["Hi-fi-området", "Det almindelige kompromis mellem kontrol og fylde. 0,7 er maksimalt fladt."];
      else if (qtc < 1.1) d = ["Fyldig", "Begyndende bump omkring resonansen. Giver mere bas i et lille kabinet, men mindre kontrol."];
      else d = ["Markant bump", "Bassen bliver kraftig men upræcis. Et st\u00f8rre kabinet vil s\u00e6nke Q<sub>tc</sub>."];

      var h = hovedResultat("System-Q", fmt(qtc, 2), "", "Qtc = Qts \u00b7 \u221a(\u03b1+1)", "Karakter", d[0], d[1]);

      h += specBoks([
        ["Systemresonans F<sub>c</sub>", fmt(fc, 1), "Hz"],
        ["\u22123 dB ved F<sub>3</sub>", fmt(f3, 1), "Hz"],
        ["Compliance-forhold \u03b1", fmt(a, 3), ""]
      ]);

      h += infoBoks("S\u00e5dan er det regnet",
        "<p><code>\u03b1 = VAS/Vb = " + fmt(a, 3) + "</code> \u00b7 " +
        "<code>Qtc = Qts\u00b7\u221a(\u03b1+1) = " + fmt(qtc, 2) + "</code> \u00b7 " +
        "<code>Fc = Fs\u00b7(Qtc/Qts) = " + fmt(fc, 1) + " Hz</code></p>" +
        "<p>Volumenet skal v\u00e6re netto \u2014 alts\u00e5 fratrukket enhed, delefilter og afstivninger.</p>");
      return h;
    }
  };

  B.basrefleks = {
    felter: [
      { id: "vas", label: "V<sub>AS</sub>", enhed: "liter", hjaelp: "Det luftvolumen, der er lige så fjedrende som enhedens ophæng." },
      { id: "qts", label: "Q<sub>ts</sub>", enhed: "", hjaelp: "Enhedens samlede godhedsfaktor. Basrefleks fungerer bedst under 0,5." },
      { id: "fs", label: "F<sub>s</sub>", enhed: "Hz", hjaelp: "Enhedens frie resonansfrekvens." },
      { id: "dport", label: "Portens indvendige diameter", enhed: "cm", hjaelp: "Målt indvendigt i røret. Større diameter giver en længere port." },
      { id: "nport", label: "Antal porte", type: "select", valg: [["1", "1"], ["2", "2"]], hjaelp: "To porte deler luftstrømmen og mindsker susen ved højt niveau." }
    ],
    knap: "Beregn kabinet og port",
    ud: function () {
      if (!(S.vas > 0 && S.qts > 0 && S.fs > 0 && S.dport > 0)) {
        return infoBoks("Udfyld felterne", "<p>Alle felter skal v\u00e6re st\u00f8rre end nul.</p>", "warn");
      }
      if (S.qts > 0.6) {
        return infoBoks("Q<sub>ts</sub> er h\u00f8j til basrefleks",
          "<p>Med Q<sub>ts</sub> = " + fmt(S.qts, 2) + " er enheden bedre egnet til et lukket kabinet. " +
          "Basrefleks fungerer typisk bedst under 0,5.</p>", "warn");
      }
      var vb = 20 * S.vas * Math.pow(S.qts, 3.3);
      var fb = S.fs * Math.pow(S.vas / vb, 0.31);
      var f3 = S.fs * Math.pow(S.vas / vb, 0.44);
      var lv = (23562.5 * S.nport * S.dport * S.dport) / (fb * fb * vb) - CFG.portK * S.dport;
      var areal = S.nport * Math.PI * Math.pow(S.dport / 2, 2);

      var h = hovedResultat("Nettovolumen", fmt(vb, 1), "l", "tunet til " + fmt(fb, 1) + " Hz", "Port",
        lv > 0 ? fmt(lv, 1) + " cm lang, \u00d8" + fmt(S.dport, 1) + " cm" : "Porten kan ikke lade sig g\u00f8re",
        lv > 0 ? "M\u00e5lt indvendigt. Er porten l\u00e6ngere, end kabinettet er dybt, kan du bukke den eller v\u00e6lge en mindre diameter."
               : "Med den diameter bliver den beregnede l\u00e6ngde negativ \u2014 kabinettet er for stort og tuningen for h\u00f8j til s\u00e5 smal en port. V\u00e6lg en st\u00f8rre portdiameter.");

      h += specBoks([
        ["Tuningfrekvens F<sub>b</sub>", fmt(fb, 1), "Hz"],
        ["\u22123 dB ved F<sub>3</sub>", fmt(f3, 1), "Hz"],
        ["Portl\u00e6ngde", lv > 0 ? fmt(lv, 1) : "\u2014", "cm"],
        ["Portareal", fmt(areal, 1), "cm\u00b2"]
      ]);

      h += infoBoks("S\u00e5dan er det regnet",
        "<p>Volumen og tuning f\u00f8lger en QB3-tiln\u00e6rmelse: <code>Vb = 20\u00b7VAS\u00b7Qts^3,3</code>, " +
        "<code>Fb = Fs\u00b7(VAS/Vb)^0,31</code>. Portl\u00e6ngden er Helmholtz-formlen med endekorrektion " +
        "k = " + CFG.portK + ": <code>Lv = 23562,5\u00b7N\u00b7D\u00b2 / (Fb\u00b2\u00b7Vb) \u2212 k\u00b7D</code></p>");

      if (lv > 0 && lv < 5) {
        h += infoBoks("Porten bliver meget kort",
          "<p>" + fmt(lv, 1) + " cm er reelt bare et hul i pladen, og luften vil suse h\u00f8rbart. " +
          "V\u00e6lg en st\u00f8rre portdiameter \u2014 l\u00e6ngden vokser med kvadratet p\u00e5 diameteren, s\u00e5 en st\u00f8rre port bliver b\u00e5de l\u00e6ngere og roligere ved samme tuning.</p>", "warn");
      }

      h += infoBoks("Kontroll\u00e9r mod en simulering",
        "<p>Basrefleks er den beregner, hvor tiln\u00e6rmelser g\u00f8r mest ondt. K\u00f8r designet igennem " +
        "WinISD eller lignende, f\u00f8r du saver \u2014 is\u00e6r hvis enheden har lang slagl\u00e6ngde.</p>", "warn");
      return h;
    }
  };

   /* Portberegner. Staar helt alene: enhedens parametre og kabinettets
     volumen giver tuningen, og derfra portens laengde. */
  B.port = {
    felter: [
      { id: "vb", label: "Kabinettets nettovolumen", enhed: "liter", hjaelp: "Det indvendige rumfang, fratrukket enhed, delefilter og afstivninger." },
      { id: "vas", label: "V<sub>AS</sub>", enhed: "liter", hjaelp: "Det luftvolumen, der er lige så fjedrende som enhedens ophæng." },
      { id: "qts", label: "Q<sub>ts</sub>", enhed: "", hjaelp: "Enhedens samlede godhedsfaktor. Basrefleks fungerer bedst under 0,5." },
      { id: "fs", label: "F<sub>s</sub>", enhed: "Hz", hjaelp: "Enhedens frie resonansfrekvens." },
      { id: "dport", label: "Portens indvendige diameter", enhed: "cm", hjaelp: "Målt indvendigt i røret. Større diameter giver en længere port." },
      { id: "nport", label: "Antal porte", type: "select", valg: [["1", "1"], ["2", "2"]], hjaelp: "To porte deler luftstrømmen og mindsker susen ved højt niveau." }
    ],
    knap: "Beregn portl\u00e6ngde",
    ud: function () {
      if (!(S.vb > 0 && S.vas > 0 && S.qts > 0 && S.fs > 0 && S.dport > 0)) {
        return infoBoks("Udfyld felterne", "<p>Alle felter skal v\u00e6re st\u00f8rre end nul.</p>", "warn");
      }
      var fb = S.fs * Math.pow(S.vas / S.vb, 0.31);
      var f3 = S.fs * Math.pow(S.vas / S.vb, 0.44);
      var lv = (23562.5 * S.nport * S.dport * S.dport) / (fb * fb * S.vb) - CFG.portK * S.dport;
      var areal = S.nport * Math.PI * Math.pow(S.dport / 2, 2);

      var h = hovedResultat("Portl\u00e6ngde", lv > 0 ? fmt(lv, 1) : "\u2014", lv > 0 ? "cm" : "",
        "\u00d8" + fmt(S.dport, 1) + " cm \u00b7 " + S.nport + (S.nport > 1 ? " porte" : " port"),
        "Port",
        lv > 0
          ? fmt(lv, 1) + " cm ved " + fmt(fb, 1) + " Hz"
          : "Porten kan ikke lade sig g\u00f8re",
        lv > 0
          ? "M\u00e5lt indvendigt i r\u00f8ret. " + fmt(S.vb, 1) + " liter med denne enhed tunes til " +
            fmt(fb, 1) + " Hz, og systemet er 3 dB nede ved " + fmt(f3, 1) + " Hz."
          : "Med den diameter bliver l\u00e6ngden negativ. V\u00e6lg en st\u00f8rre portdiameter.");

      h += specBoks([
        ["Tuningfrekvens F<sub>b</sub>", fmt(fb, 1), "Hz"],
        ["\u22123 dB ved F<sub>3</sub>", fmt(f3, 1), "Hz"],
        ["Portl\u00e6ngde", lv > 0 ? fmt(lv, 1) : "\u2014", "cm"],
        ["Portareal", fmt(areal, 1), "cm\u00b2"]
      ]);

      h += infoBoks("S\u00e5dan er det regnet",
        "<p>Tuningen f\u00f8lger af enheden og kabinettet: <code>Fb = Fs\u00b7(VAS/Vb)^0,31</code><br>" +
        "Portl\u00e6ngden er Helmholtz-formlen med endekorrektion k = " + CFG.portK + ":<br>" +
        "<code>Lv = 23562,5\u00b7N\u00b7D\u00b2 / (Fb\u00b2\u00b7Vb) \u2212 k\u00b7D</code></p>" +
        "<p>Volumenet skal v\u00e6re netto \u2014 alts\u00e5 fratrukket enhed, delefilter og afstivninger.</p>");
      return h;
    }
  };

  B.delefilter = {
    felter: [
      { id: "orden", label: "Stejlhed", type: "select",
        hjaelp: "Hvor stejlt filteret skærer. Stejlere giver renere adskillelse, men flere komponenter.",
        valg: [["1", "6 dB/oktav \u2014 1. orden"],
               ["2", "12 dB/oktav \u2014 2. orden"],
               ["4", "24 dB/oktav \u2014 4. orden Linkwitz-Riley"]] },
      { id: "topo", label: "Filtertype", type: "select",
        hjaelp: "Filterets karakter omkring delefrekvensen. Linkwitz-Riley er det almindelige valg.",
        valg: [["lr", "Linkwitz-Riley"], ["bessel", "Bessel"], ["bw", "Butterworth"], ["cheb", "Chebyshev"]] },
      { id: "fc", label: "Delefrekvens", enhed: "Hz", hjaelp: "Hvor bassen afløses af diskanten. Typisk 2000\u20133500 Hz." },
      { id: "zt", label: "Impedans, diskant", enhed: "\u03a9", hjaelp: "Diskantens nominelle impedans \u2014 oftest 4, 6 eller 8 ohm." },
      { id: "zw", label: "Impedans, bas", enhed: "\u03a9", hjaelp: "Bassens nominelle impedans \u2014 oftest 4, 6 eller 8 ohm." }
    ],
    knap: "Beregn delefilter",
    ud: function () {
      var f = S.fc, zt = S.zt, zw = S.zw, hp, lp, titel, note, formel;
      if (!(f > 0 && zt > 0 && zw > 0)) {
        return infoBoks("Udfyld felterne", "<p>Delefrekvens og begge impedanser skal v\u00e6re st\u00f8rre end nul.</p>", "warn");
      }

      if (S.orden === "1") {
        hp = [{ t: "C", p: "s", v: 0.1592 / (zt * f) }];
        lp = [{ t: "L", p: "s", v: 0.1592 * zw / f }];
        titel = "1. orden Butterworth \u00b7 6 dB/oktav";
        note = "Ved 1. orden findes kun Butterworth. Enhederne spiller langt ind over hinanden, s\u00e5 de skal kunne t\u00e5le det.";
        formel = "C = 0,1592/(R\u00b7f) \u00b7 L = 0,1592\u00b7R/f";
      } else if (S.orden === "2") {
        var k = CFG.k2[S.topo] || CFG.k2.lr;
        hp = [{ t: "C", p: "s", v: k.kC / (zt * f) }, { t: "L", p: "p", v: k.kL * zt / f }];
        lp = [{ t: "L", p: "s", v: k.kL * zw / f }, { t: "C", p: "p", v: k.kC / (zw * f) }];
        titel = "2. orden " + k.navn + " \u00b7 12 dB/oktav \u00b7 Q = " + k.q;
        note = k.note;
        formel = "C = kC/(R\u00b7f) \u00b7 L = kL\u00b7R/f \u2014 " + k.navn + ": kC = " + k.kC + ", kL = " + k.kL;
      } else {
        hp = CFG.k4.hp.map(function (c) {
          return { t: c.t, p: c.p, v: c.t === "C" ? c.k / (zt * f) : c.k * zt / f };
        });
        lp = CFG.k4.lp.map(function (c) {
          return { t: c.t, p: c.p, v: c.t === "C" ? c.k / (zw * f) : c.k * zw / f };
        });
        titel = "4. orden Linkwitz-Riley \u00b7 24 dB/oktav";
        note = "Diskanten kobles i normal fase ved 4. orden \u2014 modsat 2. orden Linkwitz-Riley, hvor den skal vendes.";
        formel = "H\u00f8jpas: 0,0844 \u00b7 0,1000 \u00b7 0,1688 \u00b7 0,4501 \u2014 Lavpas: 0,3000 \u00b7 0,0563 \u00b7 0,1500 \u00b7 0,2533";
      }

      var h = hovedResultat("Delefrekvens", fmt(f, 0), "Hz",
        (hp.length + lp.length) + " komponenter", "Filter", titel, note, true);

      h += komponentTabel("Diskant \u2014 h\u00f8jpas ved " + fmt(zt, 1) + " \u03a9", hp);
      h += komponentTabel("Bas \u2014 lavpas ved " + fmt(zw, 1) + " \u03a9", lp);
      h += diagram([{ liste: hp, enhed: "Diskant" }, { liste: lp, enhed: "Bas" }]);
      h += infoBoks("S\u00e5dan er det regnet",
        "<p><code>" + formel + "</code></p>" +
        "<p>V\u00e6rdierne foruds\u00e6tter konstant impedans. Enhedens virkelige impedans stiger med frekvensen \u2014 " +
        "brug et Zobel-led, hvis du vil t\u00e6ttere p\u00e5 papiret.</p>");
      return h;
    }
  };

  B.trevejs = {
    felter: [
      { id: "topo", label: "Filtertype", type: "select",
        hjaelp: "Filterets karakter omkring delefrekvensen. Linkwitz-Riley er det almindelige valg.",
        valg: [["lr", "Linkwitz-Riley"], ["bessel", "Bessel"], ["bw", "Butterworth"], ["cheb", "Chebyshev"]] },
      { id: "f1", label: "Delefrekvens 1", enhed: "Hz", hjaelp: "Hvor bassen afløses af mellemtonen. Typisk 300\u2013800 Hz." },
      { id: "f2", label: "Delefrekvens 2", enhed: "Hz", hjaelp: "Hvor mellemtonen afløses af diskanten. Typisk 2000\u20133500 Hz." },
      { id: "zw", label: "Impedans, bas", enhed: "\u03a9", hjaelp: "Bassens nominelle impedans." },
      { id: "zm", label: "Impedans, mellemtone", enhed: "\u03a9", hjaelp: "Mellemtonens nominelle impedans." },
      { id: "zt", label: "Impedans, diskant", enhed: "\u03a9", hjaelp: "Diskantens nominelle impedans." }
    ],
    knap: "Beregn 3-vejs filter",
    ud: function () {
      var k = CFG.k2[S.topo] || CFG.k2.lr, f1 = S.f1, f2 = S.f2;
      if (!(f1 > 0 && f2 > 0 && S.zw > 0 && S.zm > 0 && S.zt > 0)) {
        return infoBoks("Udfyld felterne", "<p>Alle frekvenser og impedanser skal v\u00e6re st\u00f8rre end nul.</p>", "warn");
      }
      if (!(f2 > f1 * 1.5)) {
        return infoBoks("Delefrekvenserne ligger for t\u00e6t",
          "<p>Mellemtonen har brug for plads. S\u00e6t mindst en oktavs afstand \u2014 helst to.</p>", "warn");
      }

      var bas = [{ t: "L", p: "s", v: k.kL * S.zw / f1 }, { t: "C", p: "p", v: k.kC / (S.zw * f1) }];
      var mid = [{ t: "C", p: "s", v: k.kC / (S.zm * f1) }, { t: "L", p: "p", v: k.kL * S.zm / f1 },
                 { t: "L", p: "s", v: k.kL * S.zm / f2 }, { t: "C", p: "p", v: k.kC / (S.zm * f2) }];
      var dis = [{ t: "C", p: "s", v: k.kC / (S.zt * f2) }, { t: "L", p: "p", v: k.kL * S.zt / f2 }];

      var h = hovedResultat("Delefrekvenser", fmt(f1, 0) + " / " + fmt(f2, 0), "Hz",
        k.navn + " \u00b7 12 dB/oktav", "Filter", "B\u00e5ndpas p\u00e5 mellemtonen",
        k.note + " Mellemtonen f\u00e5r typisk 2\u20133 dB for meget niveau p\u00e5 grund af overlappet \u2014 regn med et d\u00e6mpeled.", true);

      h += komponentTabel("Bas \u2014 lavpas ved " + fmt(f1, 0) + " Hz", bas);
      h += komponentTabel("Mellemtone \u2014 b\u00e5ndpas", mid);
      h += komponentTabel("Diskant \u2014 h\u00f8jpas ved " + fmt(f2, 0) + " Hz", dis);
      h += diagram([{ liste: bas, enhed: "Bas" }, { liste: mid, enhed: "Mellemtone" }, { liste: dis, enhed: "Diskant" }]);
      h += infoBoks("S\u00e5dan er det regnet",
        "<p><code>C = kC/(R\u00b7f) \u00b7 L = kL\u00b7R/f</code> \u2014 " + k.navn +
        ": kC = " + k.kC + ", kL = " + k.kL + ". Mellemtonen f\u00e5r b\u00e5de et h\u00f8jpas ved " +
        fmt(f1, 0) + " Hz og et lavpas ved " + fmt(f2, 0) + " Hz.</p>");
      return h;
    }
  };
  /* Volumen- og kabinetberegner. Udvendige maal ind, indvendigt volumen
     og skaereliste ud. Alle maal i millimeter. */
  B.kabinet = {
    felter: [
      { id: "kabH", label: "Højde", enhed: "mm", hjaelp: "Udvendigt mål." },
      { id: "kabB", label: "Bredde", enhed: "mm", hjaelp: "Udvendigt mål." },
      { id: "kabD", label: "Dybde", enhed: "mm", hjaelp: "Udvendigt mål." },
      { id: "kabT", label: "Trætykkelse", enhed: "mm", hjaelp: "Pladens tykkelse. MDF er typisk 19 mm." },
      { id: "kabN", label: "Antal kabinetter", type: "select", valg: [["1", "1"], ["2", "2"], ["4", "4"]], hjaelp: "Ganger antallet i skærelisten." }
    ],
    knap: "Beregn kabinet",
    ud: function () {
      var H = S.kabH, Bd = S.kabB, D = S.kabD, t = S.kabT, n = S.kabN;
      if (!(H > 0 && Bd > 0 && D > 0 && t > 0)) {
        return infoBoks("Udfyld felterne", "<p>Alle mål skal v\u00e6re st\u00f8rre end nul.</p>", "warn");
      }
      var iH = H - 2 * t, iB = Bd - 2 * t, iD = D - 2 * t;
      if (!(iH > 0 && iB > 0 && iD > 0)) {
        return infoBoks("Pladen er for tyk",
          "<p>Med " + fmt(t, 0) + " mm plade bliver der intet rum tilbage indeni. " +
          "Kontroll\u00e9r målene \u2014 de skal v\u00e6re udvendige.</p>", "warn");
      }

      var vol = (iH * iB * iD) / 1e6;
      var dele = [
        ["Front", H, Bd, 1],
        ["Bagside", H, Bd, 1],
        ["Side", H, iD, 2],
        ["Top og bund", iB, iD, 2]
      ];
      var areal = 0;
      dele.forEach(function (d) { areal += d[1] * d[2] * d[3] * n; });
      areal = areal / 1e6;

      var h = hovedResultat("Indvendigt volumen", fmt(vol, 2), "l",
        fmt(H, 0) + " \u00d7 " + fmt(Bd, 0) + " \u00d7 " + fmt(D, 0) + " mm udvendigt",
        "Kabinet",
        fmt(vol, 2) + " liter brutto",
        "Målt indvendigt mellem pladerne. Tr\u00e6k rumfanget af enhed, delefilter og " +
        "afstivninger fra, n\u00e5r du sammenligner med en kabinetberegning.");

      h += specBoks([
        ["Indvendig h\u00f8jde", fmt(iH, 0), "mm"],
        ["Indvendig bredde", fmt(iB, 0), "mm"],
        ["Indvendig dybde", fmt(iD, 0), "mm"],
        ["Pladeforbrug", fmt(areal, 2), "m\u00b2"]
      ]);

      h += kabinetTegning(H, Bd, D, t);

      var raekker = dele.map(function (d) {
        return '<tr>' +
          '<td class="sc-ref">' + d[0] + '</td>' +
          '<td class="sc-vaerdi">' + fmt(d[1], 0) + " \u00d7 " + fmt(d[2], 0) + ' mm</td>' +
          '<td class="sc-beregnet">' + (d[3] * n) + ' stk</td>' +
          '</tr>';
      }).join("");

      h += '<table class="sc-parts"><caption>Sk\u00e6reliste' +
        (n > 1 ? " \u2014 " + n + " kabinetter" : "") + '</caption>' +
        '<thead><tr><th>Del</th><th>M\u00e5l</th><th>Antal</th></tr></thead>' +
        '<tbody>' + raekker + '</tbody></table>';

      h += infoBoks("S\u00e5dan er det regnet",
        "<p>Indvendigt volumen: <code>(H\u22122t) \u00d7 (B\u22122t) \u00d7 (D\u22122t)</code></p>" +
        "<p>Front og bagside d\u00e6kker hele fladen. Siderne st\u00e5r imellem dem, og top og bund " +
        "st\u00e5r mellem siderne. Bygger du anderledes, \u00e6ndrer sk\u00e6rem\u00e5lene sig \u2014 " +
        "volumenet g\u00f8r ikke.</p>");
      return h;
    }
  };

  /* Simpel stregtegning set skraat forfra, saa forholdet mellem
     hoejde, bredde og dybde kan aflaeses. */
  function kabinetTegning(H, Bd, D, t) {
    var maxB = 300, maxH = 190;
    var s = Math.min(maxB / (Bd + D * 0.5), maxH / (H + D * 0.38));
    var w = Bd * s, hh = H * s;
    var ox = D * s * 0.5, oy = -D * s * 0.38;
    var x0 = 74, y0 = 250;
    var g = "";

    function linje(x1, y1, x2, y2, k) {
      return '<line x1="' + x1.toFixed(1) + '" y1="' + y1.toFixed(1) +
             '" x2="' + x2.toFixed(1) + '" y2="' + y2.toFixed(1) +
             '" class="' + (k || "sc-svg-wire") + '"/>';
    }

    var bx = x0 + ox, by = y0 + oy;
    g += '<g stroke-dasharray="4 4" opacity=".35">' +
         linje(x0, y0, bx, by) +
         linje(bx, by, bx, by - hh) +
         linje(bx, by, x0 + w + ox, by) +
         '</g>';

    g += linje(x0, y0, x0 + w, y0) +
         linje(x0, y0 - hh, x0 + w, y0 - hh) +
         linje(x0, y0, x0, y0 - hh) +
         linje(x0 + w, y0, x0 + w, y0 - hh);

    g += linje(x0, y0 - hh, x0 + ox, y0 - hh + oy) +
         linje(x0 + w, y0 - hh, x0 + w + ox, y0 - hh + oy) +
         linje(x0 + w, y0, x0 + w + ox, y0 + oy) +
         linje(x0 + ox, y0 - hh + oy, x0 + w + ox, y0 - hh + oy) +
         linje(x0 + w + ox, y0 - hh + oy, x0 + w + ox, y0 + oy);

    var ts = t * s;
    if (ts > 1.5) {
      g += '<rect x="' + (x0 + ts).toFixed(1) + '" y="' + (y0 - hh + ts).toFixed(1) +
           '" width="' + (w - 2 * ts).toFixed(1) + '" height="' + (hh - 2 * ts).toFixed(1) +
           '" class="sc-svg-part" fill="none" opacity=".5"/>';
    }

    g += '<text x="' + (x0 + w / 2).toFixed(1) + '" y="' + (y0 + 22) +
         '" text-anchor="middle" class="sc-svg-ref">' + fmt(Bd, 0) + ' mm</text>';
    g += '<text x="' + (x0 - 12) + '" y="' + (y0 - hh / 2).toFixed(1) +
         '" text-anchor="end" class="sc-svg-ref">' + fmt(H, 0) + ' mm</text>';
    g += '<text x="' + (x0 + w + ox / 2 + 12).toFixed(1) + '" y="' + (y0 + oy / 2 + 16).toFixed(1) +
         '" class="sc-svg-ref">' + fmt(D, 0) + ' mm</text>';

    return '<div class="sc-diagram"><h4>Proportioner</h4>' +
      '<svg viewBox="0 0 460 290" xmlns="http://www.w3.org/2000/svg" role="img" ' +
      'aria-label="Stregtegning af kabinettet set skråt forfra">' + g + '</svg>' +
      '<div class="sc-legend"><span>Den indre firkant viser pladens tykkelse</span>' +
      '<span>Stiplede linjer er skjulte kanter</span></div></div>';
  }

  B.daempeled = {
    felter: [
      { id: "db", label: "\u00d8nsket d\u00e6mpning", enhed: "dB", hjaelp: "Angiv som positivt tal." },
      { id: "zpad", label: "Enhedens impedans", enhed: "\u03a9", hjaelp: "Enhedens nominelle impedans \u2014 oftest 4, 6 eller 8 ohm." }
    ],
    knap: "Beregn d\u00e6mpeled",
    ud: function () {
      var db = Math.abs(S.db), r = S.zpad;
      if (!(db > 0 && r > 0)) {
        return infoBoks("Udfyld felterne", "<p>B\u00e5de d\u00e6mpning og impedans skal v\u00e6re st\u00f8rre end nul.</p>", "warn");
      }
      var k = Math.pow(10, db / 20);
      var rs = r * (1 - 1 / k);
      var rp = r / (k - 1);
      var liste = [{ t: "R", p: "s", v: rs }, { t: "R", p: "p", v: rp }];

      var vRs = naermeste(rs, "modstand"), vRp = naermeste(rp, "modstand");
      var h = hovedResultat("D\u00e6mpning", fmt(db, 1), "dB", "ved " + fmt(r, 1) + " \u03a9", "Modstande",
        "R1 = " + (vRs !== null ? fmt(vRs, 1) : fmt(rs, 2)) + " \u03a9 i serie \u00b7 R2 = " +
        (vRp !== null ? fmt(vRp, 1) : fmt(rp, 2)) + " \u03a9 parallelt",
        "Beregnet til " + fmt(rs, 2) + " \u03a9 og " + fmt(rp, 2) +
        " \u03a9. Kombinationen holder impedansen, s\u00e5 delefilteret arbejder som beregnet.");

      h += komponentTabel("Komponenter", liste);
      h += diagram([{ liste: liste, enhed: "Enhed" }]);
      h += infoBoks("S\u00e5dan er det regnet",
        "<p><code>k = 10^(dB/20) = " + fmt(k, 3) + "</code> \u00b7 <code>R1 = R\u00b7(1 \u2212 1/k)</code> \u00b7 " +
        "<code>R2 = R/(k \u2212 1)</code></p>" +
        "<p>Modstandene skal kunne t\u00e5le effekten. Brug mindst 10 W i et hi-fi-system \u2014 " +
        "og v\u00e6lg h\u00f8jere, hvis forst\u00e6rkeren er kraftig.</p>");
      return h;
    }
  };

  function byggFelt(f) {
    var id = "sc-" + f.id;
    var h = '<div class="sc-field" id="sc-felt-' + f.id + '"><label for="' + id + '">' + f.label +
      (f.hjaelp
        ? ' <span class="sc-q" role="button" tabindex="0" aria-expanded="false"' +
          ' aria-label="Forklaring: ' + esc(f.hjaelp) + '">?</span>'
        : "") + "</label>" +
      (f.hjaelp ? '<div class="sc-tip">' + esc(f.hjaelp) + "</div>" : "");

    if (f.type === "select") {
      h += '<select id="' + id + '" data-felt="' + f.id + '">';
      f.valg.forEach(function (v) {
        h += '<option value="' + v[0] + '">' + v[1] + "</option>";
      });
      h += "</select>";
    } else {
      h += '<div class="sc-irow' + (f.enhed ? "" : " sc-solo") + '">' +
        '<input type="text" inputmode="decimal" id="' + id + '" data-felt="' + f.id +
        '" value="' + String(S[f.id]).replace(".", ",") + '">' +
        (f.enhed ? '<span class="sc-unit">' + f.enhed + "</span>" : "") + "</div>";
    }
    if (f.hint) h += '<div class="sc-hint">' + f.hint + "</div>";
    return h + "</div>";
  }

  /* ---------- Udskrift ----------
     Rapporten bygges som en separat blok (#sc-print) direkte i body.
     Ved udskrift skjuler speakercalc.css alt andet i body, saa temaets
     header, footer, navigation og knapper ikke kommer med. Klassen
     sc-udskriver paa <html> saettes foerst, naar rapporten findes, saa
     Ctrl+P aldrig giver en tom side, hvis scriptet ikke er koert. */
  var AKTIV = null;

  var IKON_PRINT = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" ' +
    'stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
    '<path d="M6 9V2h12v7"/><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/>' +
    '<rect x="6" y="14" width="12" height="8"/></svg>';

  function byggRapport(rod, felter, ud) {
    var gammel = document.getElementById("sc-print");
    if (gammel && gammel.parentNode) gammel.parentNode.removeChild(gammel);

    var titelEl = document.querySelector("main h1") || document.querySelector("h1");
    var titel = titelEl ? titelEl.textContent.replace(/\s+/g, " ").trim() : document.title;
    var dato = new Date().toLocaleDateString("da-DK", { day: "numeric", month: "long", year: "numeric" });

    /* Indtastede vaerdier — kun felter, der er synlige paa siden */
    var input = felter.filter(function (f) {
      var el = rod.querySelector("#sc-felt-" + f.id);
      return !(el && el.style.display === "none");
    }).map(function (f) {
      var v;
      if (f.type === "select") {
        var s = rod.querySelector("#sc-" + f.id);
        v = s && s.selectedIndex >= 0 ? esc(s.options[s.selectedIndex].text) : "";
      } else {
        v = esc(String(S[f.id]).replace(".", ",")) +
          (f.enhed ? " <small>" + f.enhed + "</small>" : "");
      }
      return '<div><div class="sc-k">' + f.label + '</div><div class="sc-p-v">' + v + "</div></div>";
    }).join("");

    /* Resultatet som paa skaermen, men uden koebsknapper */
    var harKoeb = !!ud.querySelector(".sc-koeb");
    var kopi = document.createElement("div");
    kopi.innerHTML = ud.innerHTML;
    kopi.querySelectorAll(".sc-buy").forEach(function (el) { el.parentNode.removeChild(el); });
    kopi.querySelectorAll(".sc-parts thead th").forEach(function (th) {
      if (!th.textContent.trim()) th.parentNode.removeChild(th);
    });

    var sti = location.host + location.pathname;

    var r = document.createElement("div");
    r.id = "sc-print";
    r.className = "speakercalc sc-rapport";
    r.setAttribute("aria-hidden", "true");
    r.innerHTML =
      '<div class="sc-p-top">' +
        '<div class="sc-p-brand">bekent<span>.dk</span></div>' +
        '<div class="sc-p-meta">SpeakerCalc<br>' + esc(dato) + "</div>" +
      "</div>" +
      '<div class="sc-p-titel">' + esc(titel) + "</div>" +
      '<div class="sc-p-h">Indtastede v\u00e6rdier</div>' +
      '<div class="sc-p-input">' + input + "</div>" +
      '<div class="sc-p-h">Resultat</div>' +
      kopi.innerHTML +
      '<div class="sc-p-fod">' +
        (harKoeb
          ? "<p>V\u00e6rdi-kolonnen viser n\u00e6rmeste v\u00e6rdi i bekent.dk\u2019s sortiment. " +
            "Den pr\u00e6cist beregnede v\u00e6rdi og afvigelsen st\u00e5r ved siden af.</p>"
          : "") +
        "<p>Resultaterne er vejledende og bygger p\u00e5 standardformler. " +
        "Kontroll\u00e9r altid mod enhedernes datablade.</p>" +
        "<p>Beregnet " + esc(dato) + " p\u00e5 " + esc(sti) + "</p>" +
      "</div>";

    document.body.appendChild(r);
    document.documentElement.classList.add("sc-udskriver");
  }

  function start(rod) {
    var navn = rod.getAttribute("data-beregner");
    var b = B[navn];
    if (!b) {
      rod.innerHTML = '<div class="sc-info sc-warn"><div class="sc-info-t">Beregner ikke fundet</div>' +
        "<p>Sektionen er sat til \u201d" + esc(navn) + "\u201d, som ikke findes.</p></div>";
      return;
    }
    var felter = typeof b.felter === "function" ? b.felter() : b.felter;

    function synlighed() {
      var t = rod.querySelector("#sc-felt-topo");
      if (t && navn === "delefilter") t.style.display = S.orden === "2" ? "" : "none";
    }

    rod.innerHTML =
      '<div class="sc-panel"><h2>Indtast v\u00e6rdier</h2>' +
      '<div class="sc-fields">' + felter.map(byggFelt).join("") + "</div>" +
      '<button type="button" class="sc-btn">' + b.knap + "</button></div>" +
      '<div class="sc-out" aria-live="polite"></div>' +
      '<div class="sc-print-row"><a href="#" class="sc-printknap" role="button">' +
      IKON_PRINT + "<span>Udskriv / gem som PDF</span></a></div>";

    var ud = rod.querySelector(".sc-out");

    function tegn() {
      try {
        nulstilNumre();
        ud.innerHTML = b.ud();
      } catch (e) {
        ud.innerHTML = '<div class="sc-info sc-warn"><div class="sc-info-t">Beregningen fejlede</div>' +
          "<p>Kontroll\u00e9r de indtastede v\u00e6rdier.</p></div>";
        if (window.console) console.error("SpeakerCalc:", e);
      }
    }

    AKTIV = function () { byggRapport(rod, felter, ud); };

    rod.querySelectorAll("input[data-felt]").forEach(function (i) {
      i.addEventListener("input", function () {
        var v = num(i.value);
        if (isFinite(v)) S[i.getAttribute("data-felt")] = v;
        tegn();
      });
    });

    /* Xtra tegner sin egen visning oven paa select-felter og opdaterer den
       kun ved change. Vi saetter derfor vaerdien og udloeser haendelsen selv. */
    function saetValg() {
      rod.querySelectorAll("select[data-felt]").forEach(function (s) {
        var felt = s.getAttribute("data-felt");
        if (S[felt] === undefined) return;
        var oensket = String(S[felt]);
        for (var i = 0; i < s.options.length; i++) {
          if (s.options[i].value === oensket) {
            s.selectedIndex = i;
            s.dispatchEvent(new Event("change", { bubbles: true }));
            return;
          }
        }
      });
    }

    rod.querySelectorAll("select[data-felt]").forEach(function (s) {
      var felt = s.getAttribute("data-felt");
      if (S[felt] !== undefined) s.value = String(S[felt]);
      s.addEventListener("change", function () {
        var v = num(s.value);
        S[felt] = (felt === "topo" || felt === "orden") ? s.value : (isFinite(v) ? v : s.value);
        synlighed();
        tegn();
      });
    });

    saetValg();
    synlighed();

    setTimeout(saetValg, 0);
    setTimeout(function () { saetValg(); synlighed(); }, 400);
    setTimeout(function () { saetValg(); synlighed(); }, 1200);

    /* Hjaelpetekster. Browserens title-attribut virker ikke paa touch, saa
       teksten ligger som en blok i feltet og foldes ud ved tryk. */
    function lukAlle(undtagen) {
      rod.querySelectorAll(".sc-field.sc-aaben").forEach(function (felt) {
        if (felt !== undtagen) {
          felt.classList.remove("sc-aaben");
          var k = felt.querySelector(".sc-q");
          if (k) k.setAttribute("aria-expanded", "false");
        }
      });
    }

    function skift(q) {
      var felt = q.closest ? q.closest(".sc-field") : null;
      if (!felt) return;
      var aaben = felt.classList.contains("sc-aaben");
      lukAlle(felt);
      felt.classList.toggle("sc-aaben", !aaben);
      q.setAttribute("aria-expanded", aaben ? "false" : "true");
    }

    rod.addEventListener("click", function (e) {
      var q = e.target.closest ? e.target.closest(".sc-q") : null;
      if (q) {
        e.preventDefault();
        e.stopPropagation();
        skift(q);
      } else {
        lukAlle(null);
      }
    });

    rod.addEventListener("keydown", function (e) {
      if (e.key === "Escape") { lukAlle(null); return; }
      var t = e.target;
      if (!t.classList || !t.classList.contains("sc-q")) return;
      if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") {
        e.preventDefault();
        skift(t);
      }
    });

    document.addEventListener("click", function (e) {
      if (!rod.contains(e.target)) lukAlle(null);
    });

    rod.querySelector(".sc-btn").addEventListener("click", function () {
      tegn();
      ud.scrollIntoView({ behavior: "smooth", block: "start" });
    });

    rod.querySelector(".sc-printknap").addEventListener("click", function (e) {
      e.preventDefault();
      tegn();
      byggRapport(rod, felter, ud);
      window.print();
    });

    tegn();
  }

  function init() {
    var rodder = document.querySelectorAll("[data-speakercalc]");
    for (var i = 0; i < rodder.length; i++) start(rodder[i]);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  /* Ctrl+P / browserens egen udskriv-menu bygger ogsaa rapporten */
  window.addEventListener("beforeprint", function () {
    if (AKTIV) AKTIV();
  });

  document.addEventListener("shopify:section:load", function (e) {
    var rod = e.target.querySelector("[data-speakercalc]");
    if (rod) start(rod);
  });

})();